import React, { Component } from 'react';
import ArticleTable from "../../Tables/ExtraLargeArticle";
import IntlMessages from 'util/IntlMessages';

export default class ArtikelTabell extends Component {
    render() {
        return (
            <div className="text-center" style={{ color: 'white' }}>
                <div>
                    <h2 style={{ paddingTop: '12px', fontSize:"1.5rem" }}><b><IntlMessages id="Products"/></b></h2>
                </div>
                <div className="d-flex justify-content-center">
                    <ArticleTable isFrom={this.props.isFrom} Afid={this.props.Afid} Kontor={this.props.Kontor}/>
                </div>
            </div>
        )
    }
}
